import React from 'react';
import ProfileLayout from './ProfileLayout';
import { useUserFirstLetter } from '../hooks/useUserFirstLetter';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Title = styled.h1`
  font-size: 38px !important;
  font-style: normal;
  font-weight: 700;
  line-height: 52px;
  letter-spacing: 0.8px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 16px;
  margin-bottom: 32px;
`;
const Th = styled.th`
  text-align: left;
  font-size: 14px;
  color: #888;
  font-weight: 600;
  white-space: nowrap;
`;
const Td = styled.td`
  background: #fff;
  font-size: 14px;
  vertical-align: middle;
  padding: 20px 0px;
  line-height: 16px;

  &:last-child {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  @media (max-width: 700px) {
    &:last-child {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 6px;
    }
  }
`;
const CancelButton = styled.button`
  background: #3baab0;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  float: right;
  transition: background .2s;
  &:hover {
    background: #218b8f;
  }
`;

export default function Orders() {
  const { t } = useTranslation();
  const firstLetter = useUserFirstLetter();
  return (
    <ProfileLayout activeTab="orders" firstLetter={firstLetter}>
      <Title>{t('ordersAndSubscriptions')}</Title>
      <Table style={{ borderSpacing: 0 }}>
        <thead>
          <tr>
            <Th>{t('item')}</Th>
            <Th>{t('dateOrdered')}</Th>
            <Th>{t('price')}</Th>
          </tr>
        </thead>
        <tbody style={{ borderSpacing: 0 }}>
          {/* <tr>
            <Td>Basic-Checkup</Td>
            <Td>13 July 2025</Td>
            <Td>Free of charge</Td>
          </tr>
          <tr>
            <Td>Smrtlife Yearly Subscription</Td>
            <Td>13 July 2025</Td>
            <Td>
              CHF 108.20
              <CancelButton>Cancel</CancelButton>
            </Td>
          </tr> */}
        </tbody>
      </Table>
    </ProfileLayout>
  );
} 